<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M82.5-82.5V-559l275-117v79.5l200-80v119h320v475h-795Zm360-160h75v-155h-75v155Zm-160 0h75v-155h-75v155Zm320 0h75v-155h-75v155Zm268-370h-182L723-875h114.5l33 262.5Z"/></svg>
</template>
